import { getEditableField } from '../store';
export var buildApiPayloadCampaignNameFromStore = function (params) {
    var store = params.store;
    var state = store.getState();
    var displayNameField = getEditableField(state, 'displayName');
    var apiPayload = {
        displayName: displayNameField.value,
    };
    return apiPayload;
};
